import replaceDomain from '@/utils/replaceDomain';
import { APP_US_ADMIN } from './app';

/*
 * Define default-api from specified environment
 * And change to us-api when user open us-domain page
 */

export const API_ADMIN_BASEURL = replaceDomain(
  process.env.VUE_APP_API_URL,
  APP_US_ADMIN,
  APP_US_ADMIN,
);

export const API_ADMIN_TIMEOUT = process.env.VUE_APP_API_TIMEOUT;

/*
 * Intercom baseURL based on default-api
 */

function createIntercomBaseURL(baseURL) {
  return `${baseURL}/v1/support/intercom`;
}

export const API_INTERCOM_BASEURL = createIntercomBaseURL(API_ADMIN_BASEURL);
export const API_INTERCOM_TIMEOUT = process.env.VUE_APP_API_TIMEOUT;

/*
 * Media baseURL for downloads based on default-api
 */

function createMediaBaseURL(baseURL) {
  return baseURL.slice(0, -4);
}

export const API_MEDIA_BASEURL = createMediaBaseURL(API_ADMIN_BASEURL);
export const API_MEDIA_TIMEOUT = process.env.VUE_APP_API_TIMEOUT;

/*
 * Create api-switch map and options
 */

function createSwitchMap(baseURL) {
  return [
    {
      name: 'eu',
      label: 'UK',
      icon: 'globe-uk-eu',
      baseURL,
      country: ['default', 'gb', 'de', 'dk', 'ch', 'ca'],
    },
    {
      name: 'uae',
      label: 'UAE',
      icon: 'globe-uae',
      baseURL: baseURL.replace(/^(https?:\/\/)uk([.-])/, '$1uae$2'),
      country: ['ae', 'sa'],
    },
    {
      name: 'us',
      label: 'US',
      icon: 'globe-us',
      baseURL: baseURL.includes('test-')
        ? baseURL.replace('test-admin', 'us-sandbox').replace('test-pay', 'us-pay-sandbox')
        : baseURL.replace(/^(https?:\/\/)uk([.-])/, '$1us$2'),
      country: ['us'],
    },
  ].filter((item) => Boolean(item.baseURL)).filter((item, index, other) => {
    return other.findIndex((it) => it.baseURL === item.baseURL) <= index;
  });
}

export const API_SWITCH_VAR = '_easytip-server';
export const API_SWITCH_ENABLED = process.env.VUE_APP_API_SWITCH === 'true';
export const API_SWITCH_ADMIN = createSwitchMap(process.env.VUE_APP_API_URL);
export const API_SWITCH_INTERCOM = createSwitchMap(createIntercomBaseURL(process.env.VUE_APP_API_URL));
export const API_SWITCH_MEDIA = createSwitchMap(createMediaBaseURL(process.env.VUE_APP_API_URL));
